import { PortableTextComponentProps } from "@portabletext/react";
import { parse } from "node-html-parser";
import { useEffect, useMemo } from "react";
import logger from "@/utils/logger";
import styles from "./EmbeddedHtml.module.scss";

const EmbeddedHtml = ({
  value,
  index,
}: PortableTextComponentProps<{ html: string }>) => {
  const document = useMemo(() => parse(value.html), [value.html]);

  const script = useMemo(() => document.querySelector("script"), [document]);

  useEffect(() => {
    const scriptElem = window.document.createElement("script");
    if (scriptElem) {
      scriptElem.src = script?.attrs?.src ?? "";
      scriptElem.async = true;
      window.document.body.appendChild(scriptElem);
    }

    return () => {
      try {
        window.document.body.removeChild(scriptElem);
      } catch {
        logger.info("no script");
      }
    };
  }, [script]);

  return (
    <div className={styles.container}>
      <div
        className={styles.htmlContainer}
        dangerouslySetInnerHTML={{ __html: value.html }}
      />
      {script?.rawText && (
        <script
          dangerouslySetInnerHTML={{ __html: script?.rawText }}
          id={`inner${index}`}
        />
      )}
    </div>
  );
};

export default EmbeddedHtml;
